<template>
  <hr-adaptive-form-dialog
    ref="dialog"
    size="sm"
    data-e2e="dialog-request-signature"
    :title="$t('signature.btnRequestSignature')"
    @hide="onDialogHide"
    @submit="onSubmit"
  >
    <div class="row q-col-gutter-sm">
      <hr-list-select
        v-if="showSignatoryOptions"
        v-model="signatoryId"
        data-e2e="dropdown-signatory"
        :options="signatoryOptions"
        :label="$t('sessions.modals.signature.labelClientDataField')"
        emit-value
        map-options
        clearable
        hide-bottom-space
        outlined
        class="col-12"
        @update:model-value="onSelectSignatory"
      />
      <client-users-selector
        v-if="!signatoryId"
        v-model="selectedUser"
        data-e2e="dropdown-signature-request-user"
        :session-id="sessionId"
        :client="clientId"
        :skip-users="skipUsers"
        skip-current-user
        class="col-12"
      />
    </div>
    <template #actions>
      <hr-dismiss-btn
        :label="$t('common.buttonCancel')"
        @click="hide"
      />
      <hr-confirm-btn
        :disable="!isValid"
        :label="$t('signature.btnRequest')"
        data-e2e="button-submit-signature-request"
        type="submit"
      />
    </template>
  </hr-adaptive-form-dialog>
</template>

<script>
import ClientUsersSelector from 'components/UI/ClientUsersSelector';
import { find, isEmpty } from 'lodash';
import {
  HrConfirmBtn,
  HrDismissBtn,
  HrAdaptiveFormDialog,
  HrListSelect,
} from 'src/design-system';

export default {
  name: 'RequestSignature',

  components: {
    ClientUsersSelector,
    HrConfirmBtn,
    HrDismissBtn,
    HrAdaptiveFormDialog,
    HrListSelect,
  },

  props: {

    sessionId: {
      type: String,
      default: '',
    },

    clientId: {
      type: String,
      default: null,
    },

    skipUsers: {
      type: Array,
      default: () => ([]),
    },

    signatoryOptions: {
      type: Array,
      default: () => ([]),
    },
  },

  emits: ['ok', 'hide'],

  data() {
    return {
      signatoryId: null,
      selectedUser: null,
    };
  },

  computed: {
    showSignatoryOptions() {
      return !isEmpty(this.signatoryOptions);
    },

    isValid() {
      return this.signatoryId || this.selectedUser;
    },
  },

  methods: {

    onSubmit() {
      const signatory = find(this.signatoryOptions, { value: this.signatoryId }) || null;
      this.$emit('ok', { selectedUser: this.selectedUser, signatory });
      this.hide();
    },

    onDialogHide() {
      this.$emit('hide');
    },

    show() {
      this.$refs.dialog.show();
    },

    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    },

    onSelectSignatory(value) {
      this.selectedUser = null;
    },

  },
};
</script>
